import React from "react";
import styled from "styled-components";
import { Row, Column, Text, Title } from "../../../theme";
import crosshairs from "../../../../assets/crosshair.svg";
import lens from "../../../../assets/lens.svg";
import check from "../../../../assets/check.svg";
import money from "../../../../assets/money.svg";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5em 0;
`;

const StyledOrangeColumn = styled(Column)`
  background-color: #ffa566;
  border: 1px solid #2b2b2b;
  padding: 0.5em;
  max-width: 375px;
`;

const StyledBox = styled(Column)`
  width: 100%;
  height: 100%;
  align-items: center;
  margin: 2em 0;
  text-align: center;
`;

const Img = styled.img`
  height: 125px;
`;

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 50px;
  height: 100%;
  margin: 3em auto;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  grid-auto-rows: 300px;
`;

const StyledColumn = styled(Column)`
  width: 35%;
  @media (max-width: 780px) {
    width: 95%;
  }
`;

const StyledRow = styled(Row)`
  justify-content: space-around;
  @media (max-width: 780px) {
    flex-direction: column;
    align-items: center;
  }
`;

const values = [
  {
    title: "QUALITY",
    description:
      "We guarantee a premium education for every course you choose.",
    img: check
  },
  {
    title: "AFFORDABILITY",
    description:
      "Our goal is to bring you forward with education, not to set you back.",
    img: money
  },
  {
    title: "SIMPLICITY",
    description:
      "You’ll find the courses easy to follow with pinpoint accuracy on all subjects.",
    img: crosshairs
  },
  {
    title: "CLARITY",
    description:
      "Our courses are carefully written to aid you in understanding the material.",
    img: lens
  }
];

function Box({ img, title, text }) {
  return (
    <StyledBox>
      <Img src={img} alt={`${img} Icon AchieveCE`} />
      <Column width="85%">
        <Text protitle color="#2b2b2b">
          {title}
        </Text>
        <Text color="#2b2b2b">{text}</Text>
      </Column>
    </StyledBox>
  );
}

const Values = () => {
  return (
    <Wrapper>
      <StyledRow>
        <StyledColumn>
          <Text textalign="left" color="#2b2b2b">
            Our writers are industry professionals which are each handpicked to
            be a part of our team. Their focus is to provide quality CE content
            that is relevant, readable and even enjoyable.
          </Text>
          <Text textalign="left" color="#2b2b2b">
            We provide the necessary tools for effective compliance. Whether
            your State audits certificates or is managed by CE Broker, we'll
            make sure that you are taken care of. All credits are reported to CE
            Broker within 24 hours of completion.
          </Text>
        </StyledColumn>
        <StyledOrangeColumn>
          <Text>
            We believe that everyone should have access to quality CE at an
            affordable rate. We even provide a great range of completely free CE
            – yes, you heard that right, we make FREE CE courses available for
            each profession we support.
          </Text>
        </StyledOrangeColumn>
      </StyledRow>

      <Column alignitems="center" margin="5em 0 0 0">
        <Title>Values</Title>
        <Grid>
          {values &&
            values.map((key, index) => {
              return (
                <Box
                  key={index}
                  img={key.img}
                  title={key.title}
                  text={key.description}
                />
              );
            })}
        </Grid>
      </Column>
    </Wrapper>
  );
};

export default Values;



// WEBPACK FOOTER //
// ./src/components/screens/About/components/Values.jsx